import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
const sliceName = "usa";
export const fetchUsaStats = createAsyncThunk(
  `${sliceName}/fetchUsaStats`,
  async () => {
    const res = await fetch("https://disease.sh/v3/covid-19/states");
    const data = await res.json();
    return data;
  }
);
export const usaSlice = createSlice({
  name: sliceName,
  initialState: {
    usdata: [],
    isLoading: false,
    error: "",
  },
  reducers: {},
  extraReducers: {
    [fetchUsaStats.pending]: (state, action) => {
      state.error = null;
      state.isLoading = true;
    },
    [fetchUsaStats.fulfilled]: (state, action) => {
      state.error = null;
      state.isLoading = false;
      state.usdata = action.payload;
    },
    [fetchUsaStats.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = "Sorry no data available, please try later";
    },
  },
});
export const { actions, reducer } = usaSlice;
export default reducer;
export const selectUsaStats = (state) => state.usaStats;
